var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAurora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18,
    r: 18,
    fill: "#70D44B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5005 7.60418C18.934 7.60279 19.3593 7.72281 19.7281 7.95066C20.0969 8.1785 20.3946 8.50505 20.5874 8.89335L27.1499 22.0184C27.328 22.3742 27.4121 22.7696 27.3943 23.167C27.3765 23.5644 27.2574 23.9507 27.0483 24.2891C26.8392 24.6275 26.547 24.9069 26.1995 25.1006C25.8521 25.2943 25.4609 25.396 25.0631 25.396H11.938C11.5402 25.396 11.1489 25.2943 10.8015 25.1006C10.454 24.9069 10.1619 24.6275 9.95276 24.2891C9.74365 23.9507 9.62454 23.5644 9.60675 23.167C9.58896 22.7696 9.67306 22.3742 9.85109 22.0184L16.4136 8.89335C16.6064 8.50505 16.9041 8.1785 17.2729 7.95066C17.6417 7.72281 18.067 7.60279 18.5005 7.60418ZM18.5005 6C17.7693 5.99992 17.0526 6.20342 16.4305 6.58772C15.8085 6.97202 15.3058 7.52193 14.9786 8.17585L8.41608 21.3009C8.11574 21.9013 7.97387 22.5684 8.00396 23.2391C8.03404 23.9097 8.23507 24.5615 8.58796 25.1325C8.94085 25.7036 9.43387 26.1749 10.0202 26.5018C10.6065 26.8287 11.2667 27.0002 11.938 27.0001H25.0631C25.7343 27.0002 26.3945 26.8287 26.9808 26.5018C27.5672 26.1749 28.0602 25.7036 28.4131 25.1325C28.766 24.5615 28.967 23.9097 28.9971 23.2391C29.0272 22.5684 28.8853 21.9013 28.5849 21.3009L22.0224 8.17585C21.6953 7.52193 21.1925 6.97202 20.5705 6.58772C19.9484 6.20342 19.2317 5.99992 18.5005 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAurora);
export default __webpack_public_path__ + "static/media/aurora.3ad64a08a6421e828cec00fd6d6d5086.svg";
export { ForwardRef as ReactComponent };